module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n5n9n3r-e2781c8a3e7f467617429e4c805d33ab.svg";